import React, {useEffect, useState} from "react";
import * as Sentry from '@sentry/browser';
import {FormattedMessage} from "react-intl";
import Api from "../../Api";
import {withAuth} from "../../hoc/Auth";
import TableRow from "./TableRow";
import ProjectMobileCard from "../ProjectMobileCard";
import Loader from "../Utils/Loader";
import classes from "./styles.module.css";

const ProjectsTable = withAuth(({token}) => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hasCrm, setHasCrm] = useState(false);

    var hasExtendedBalances = projects.some(function (p) {
        return p && (p.settlementBalance !== undefined || p.actualBalance !== undefined);
    });

    useEffect(() => {
        var api = new Api({token});
        api.getProjects()
            .then(function (r) {
                setProjects(r || []);
                setLoading(false);
            })
            .catch(function (err) { Sentry.captureException(err); setLoading(false); });
        api.getMerchantBalances()
            .then(function (r) {
                if (r && r.totals && r.totals.hasCrm) setHasCrm(true);
            })
            .catch(function (err) { Sentry.captureException(err); });
    }, [token]);

    return loading ? (
        <Loader/>
    ) : (
        <React.Fragment>
            <table className={classes.Table}>
                <thead>
                <tr>
                    <th><FormattedMessage id="ProjectsTable.table.project" defaultMessage="Проект"/></th>
                    {hasExtendedBalances ? (
                        <React.Fragment>
                            <th><FormattedMessage id="ProjectsTable.table.transactionBalance" defaultMessage="Транзакционный"/></th>
                            <th>
                                {hasCrm ? (
                                    <FormattedMessage
                                        id="ProjectsTable.table.reservedBalance"
                                        defaultMessage="Резервный"
                                    />
                                ) : (
                                    <FormattedMessage
                                        id="ProjectsTable.table.settlementBalance"
                                        defaultMessage="Возмещение"
                                    />
                                )}
                            </th>
                            <th><FormattedMessage id="ProjectsTable.table.actualBalance" defaultMessage="Действительный"/></th>
                        </React.Fragment>
                    ) : (
                        <th><FormattedMessage id="ProjectsTable.table.balance" defaultMessage="Баланс"/></th>
                    )}
                    <th><FormattedMessage id="ProjectsTable.table.status" defaultMessage="Статус"/></th>
                    <th><FormattedMessage id="ProjectsTable.table.site" defaultMessage="Сайт"/></th>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {projects.map(function (row) {
                    return <TableRow key={row && row.uuid} data={row} hasExtendedBalances={hasExtendedBalances}/>;
                })}
                </tbody>
            </table>

            <div className={classes.MobileList}>
                {projects.map(function (row) {
                    return (
                        <ProjectMobileCard
                            key={row && row.uuid}
                            data={row}
                            hasExtendedBalances={hasExtendedBalances}
                            hasCrm={hasCrm}
                        />
                    );
                })}
            </div>
        </React.Fragment>
    );
});

export default ProjectsTable;



// WEBPACK FOOTER //
// ./src/Components/ProjectsTable/index.js